import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IVolunteerAttendance } from './models';
import { invalidateVolunteerRoster } from './useVolunteerRoster';

export const useRegisterVolunteerMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: IVolunteerAttendance) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			activityId,
			contactId,
			shiftId,
			roleId,
			date,
			impersonationContext,
		}: {
			activityId: string;
			contactId: string;
			shiftId?: string;
			roleId?: string;
			date?: string;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<IVolunteerAttendance>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `volunteering/activities/${activityId}/attendance`,
				}),
				'POST',
				{ contactId, shiftId, roleId, date }
			),
		onSuccess: (data, variables) => {
			invalidateVolunteerRoster(variables.activityId);
			onSuccess?.(data);
		},
		onError,
	});
};
